export const TOKEN_RECEIVED = 'TOKEN_RECEIVED';
export const TOKEN_EXPIRED = 'TOKEN_EXPIRED';
export const TOKEN_OTP_RECEIVED = 'TOKEN_OTP_RECEIVED';
export const TOKEN_OTP_EXPIRED = 'TOKEN_OTP_EXPIRED';
